var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.498,
    height: 29,
    viewBox: "0 0 26.498 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user-profile",
    transform: "translate(-257.451 -148.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M283.12,148.236H258.28a.828.828,0,0,0-.829.829v17.509a.828.828,0,0,0,.829.829h5.155a11.53,11.53,0,0,0-4.489,9,.827.827,0,0,0,.829.829h18.613a.828.828,0,0,0,.829-.829,11.592,11.592,0,0,0-3.455-8.137l1.253-.868h6.107a.827.827,0,0,0,.829-.829V149.065A.827.827,0,0,0,283.12,148.236Zm-5.6,27.343h-16.88a9.406,9.406,0,0,1,5.674-7.888v5.537a.829.829,0,0,0,1.3.681l6.75-4.671A10.1,10.1,0,0,1,277.519,175.579Zm4.773-9.833h-5.536a.826.826,0,0,0-.472.147l-8.312,5.754v-5.073a.828.828,0,0,0-.829-.829h-8.034V149.893h23.183Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M267.339,162.456a4.773,4.773,0,1,0-4.774-4.773A4.778,4.778,0,0,0,267.339,162.456Zm0-7.89a3.116,3.116,0,1,1-3.117,3.117A3.12,3.12,0,0,1,267.339,154.566Z",
    transform: "translate(3.361 3.071)",
    fill: "#333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfile);
export default __webpack_public_path__ + "static/media/icon-user-profile.7aee825192d39982b213ed462208b443.svg";
export { ForwardRef as ReactComponent };